export default __webpack_public_path__ + "static/media/사회봉사.5bcfebb0.png";